module.exports = (__webpack_require__(47))(134);


//////////////////
// WEBPACK FOOTER
// delegated ./clients/web/src/index.js from dll-reference girder_lib
// module id = 334
// module chunks = 0